var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.9C0 51.1 14.7 65.8 32.9 65.8C51.1 65.8 65.8 51.1 65.8 32.9C65.8 14.7 51.1 0 32.9 0C14.8 0 0 14.7 0 32.9Z",
    fill: "#7D2AE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.9C0 51.1 14.7 65.8 32.9 65.8C51.1 65.8 65.8 51.1 65.8 32.9C65.8 14.7 51.1 0 32.9 0C14.8 0 0 14.7 0 32.9Z",
    fill: "url(#paint0_radial_5_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.9C0 51.1 14.7 65.8 32.9 65.8C51.1 65.8 65.8 51.1 65.8 32.9C65.8 14.7 51.1 0 32.9 0C14.8 0 0 14.7 0 32.9Z",
    fill: "url(#paint1_radial_5_5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.9C0 51.1 14.7 65.8 32.9 65.8C51.1 65.8 65.8 51.1 65.8 32.9C65.8 14.7 51.1 0 32.9 0C14.8 0 0 14.7 0 32.9Z",
    fill: "url(#paint2_radial_5_5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.9C0 51.1 14.7 65.8 32.9 65.8C51.1 65.8 65.8 51.1 65.8 32.9C65.8 14.7 51.1 0 32.9 0C14.8 0 0 14.7 0 32.9Z",
    fill: "url(#paint3_radial_5_5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.9C0 51.1 14.7 65.8 32.9 65.8C51.1 65.8 65.8 51.1 65.8 32.9C65.8 14.7 51.1 0 32.9 0C14.8 0 0 14.7 0 32.9Z",
    fill: "url(#paint4_radial_5_5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2 39.1C46 39.1 45.8 39.3 45.6 39.7C43.2 44.6 39.1 48 34.3 48C28.8 48 25.3 43 25.3 36.1C25.3 24.4 31.8 17.6 37.5 17.6C40.2 17.6 41.8 19.3 41.8 22C41.8 25.2 40 26.9 40 28C40 28.5 40.3 28.8 40.9 28.8C43.4 28.8 46.3 25.9 46.3 21.9C46.3 18 42.9 15.1 37.2 15.1C27.7 15.1 19.3 23.9 19.3 36C19.3 45.4 24.7 51.6 32.9 51.6C41.7 51.6 46.8 42.9 46.8 40C46.8 39.4 46.5 39.1 46.2 39.1Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7214 58.3325) rotate(-49.4156) scale(50.9056 50.9056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4491 7.47682) rotate(54.7035) scale(57.4056 57.4056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7318 58.3007) rotate(-45.1954) scale(50.2893 23.1288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9404 8.8548) rotate(66.5198) scale(51.8192 86.8084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.7259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.48668 1.83876) rotate(48.8515) scale(55.484 92.948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.7259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanva);
export default __webpack_public_path__ + "static/media/canva.bd2815223464533940b57952dc60bd58.svg";
export { ForwardRef as ReactComponent };